export default {
	setUser ({ commit }, user) {
		commit('SET_NAME', user.name)
		commit('SET_EMAIL', user.email)
		commit('SET_ID', user.sub)
		commit('SET_ROLE', user['https://getbusie.com/roles'][0])
		commit('SET_PROFILE_PICTURE', user.picture)
	}
}